import { Author } from '../../../models/types/Author.type'
import ListicleAuthors from './ListicleAuthors'

type WrittenByProps = {
    author: Author[]
    locale: string
    listicleDate: Date
    baseUrl: string
}

const WrittenBy = ({ author, locale, listicleDate, baseUrl }: WrittenByProps) => {
  return (
    <div className='written-by'>
      <div>
        <ListicleAuthors baseUrl={baseUrl} authors={author} listicleDate={listicleDate} locale={locale} />
      </div>
      <style jsx>{`
        .written-by {
          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: center;
          text-align: center;
          max-width: 800px;
          width: 100%;
          margin: 0px 6px;
        }
      `}</style>
    </div>
  )
}

export default WrittenBy
